/**
 * Header search → Searchanise only. Toggles a visible panel with name="q"; no Shopify search modal.
 * Heavy [SearchaniseHeader] console logging for debugging (see README in comments below).
 *
 * In DevTools Console you can run:  debugSearchaniseHeader()
 */
(function () {
  'use strict';

  var PREFIX = '[SearchaniseHeader]';
  var ATTR = '[data-searchanise-header-trigger]';
  var ROOT_SEL = '[data-header-searchanise]';
  var HEADER_INPUT_ATTR = 'data-header-searchanise-input';
  var AC_RES_ID = 'snize-instant-search-results';
  /** When set, theme + .snize CSS pair the pill with the instant dropdown visually */
  var AC_VISIBLE_CLASS = 'header-searchanise--ac-visible';
  var BODY_INSTANT_OPEN = 'header-searchanise--instant-open';
  var acSyncTimer = null;

  /** @type {HTMLInputElement|HTMLTextAreaElement|null} */
  var cachedInput = null;

  function log() {
    var a = Array.prototype.slice.call(arguments);
    a.unshift(PREFIX);
    console.info.apply(console, a);
  }

  function warn() {
    var a = Array.prototype.slice.call(arguments);
    a.unshift(PREFIX);
    console.warn.apply(console, a);
  }

  function describe(el) {
    if (!el || !el.nodeType) return String(el);
    var id = el.id ? '#' + el.id : '';
    var cls = el.className && String(el.className).slice(0, 120);
    return el.tagName + id + (cls ? '.' + cls.replace(/\s+/g, '.') : '');
  }

  function logSearchaniseScripts() {
    var hits = [];
    document.querySelectorAll('script[src]').forEach(function (s) {
      var src = s.getAttribute('src') || '';
      if (/snize|searchanise|searchserverapi/i.test(src)) hits.push(src);
    });
    log('STEP diag: script tags (snize/searchanise/api):', hits.length ? hits : '(none found)');
  }

  function logIframes() {
    var hits = [];
    document.querySelectorAll('iframe[src]').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (/snize|searchanise|searchserverapi/i.test(src)) hits.push(src);
    });
    if (hits.length) log('STEP diag: iframes (search-related):', hits);
  }

  function logSnizeLikeRoots() {
    var roots = document.querySelectorAll('[id*="snize"], [id*="Snize"], [class*="snize"], [class*="Snize"]');
    log('STEP diag: elements with id/class containing "snize":', roots.length);
    for (var i = 0; i < Math.min(roots.length, 8); i++) {
      var r = roots[i];
      var inputs = r.querySelectorAll ? r.querySelectorAll('input, textarea') : [];
      log('  [' + i + ']', describe(r), 'child inputs:', inputs.length);
      for (var j = 0; j < Math.min(inputs.length, 3); j++) {
        log('    input[' + j + ']', describe(inputs[j]), 'type=', inputs[j].type, 'name=', inputs[j].name);
      }
    }
  }

  function getSearchaniseJquery() {
    var sn = window.Searchanise;
    if (sn && typeof sn.$ === 'function') return sn.$;
    return null;
  }

  function getPanel(root) {
    return root.querySelector('[data-header-searchanise-panel]');
  }

  function getToggle(root) {
    return root.querySelector(ATTR);
  }

  function isPanelOpen(root) {
    var p = getPanel(root);
    return !!(p && !p.hidden);
  }

  function syncScrollLock() {
    var any = false;
    document.querySelectorAll(ROOT_SEL).forEach(function (r) {
      if (isPanelOpen(r)) any = true;
    });
    document.documentElement.classList.toggle('header-searchanise-scroll-lock', any);
    document.body.classList.toggle('header-searchanise-scroll-lock', any);
  }

  function closePanel(root) {
    var panel = getPanel(root);
    var btn = getToggle(root);
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    root.classList.remove('header-searchanise--open');
    root.classList.remove(AC_VISIBLE_CLASS);
    syncScrollLock();
    scheduleAutocompleteVisualSync();
  }

  function openPanel(root) {
    var panel = getPanel(root);
    var btn = getToggle(root);
    if (!panel) return;
    panel.hidden = false;
    if (btn) btn.setAttribute('aria-expanded', 'true');
    root.classList.add('header-searchanise--open');
    syncScrollLock();
    scheduleAutocompleteVisualSync();
  }

  function isInstantResultsVisible(el) {
    if (!el || el.nodeType !== 1) return false;
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /**
   * Instant results are often appended outside the header overlay; toggle classes so CSS can
   * connect the pill + #snize-instant-search-results (width, radius, border, shadow).
   */
  function syncAutocompleteVisualConnection() {
    var ac = document.getElementById(AC_RES_ID);
    var visible = isInstantResultsVisible(ac);
    var overlayOpen = !!document.querySelector('[data-header-searchanise-panel]:not([hidden])');
    document.body.classList.toggle(BODY_INSTANT_OPEN, !!(visible && overlayOpen));

    if (!visible) {
      document.querySelectorAll(ROOT_SEL).forEach(function (r) {
        r.classList.remove(AC_VISIBLE_CLASS);
      });
    } else {
      var input = document.activeElement;
      if (!input || !input.getAttribute || input.getAttribute(HEADER_INPUT_ATTR) === null) {
        input = cachedInput || document.querySelector('[' + HEADER_INPUT_ATTR + ']');
      }
      var root = input && input.closest && input.closest(ROOT_SEL);
      document.querySelectorAll(ROOT_SEL).forEach(function (r) {
        r.classList.toggle(AC_VISIBLE_CLASS, root ? r === root : false);
      });
    }

    var inputForMount = document.activeElement;
    if (!inputForMount || !inputForMount.getAttribute || inputForMount.getAttribute(HEADER_INPUT_ATTR) === null) {
      inputForMount = cachedInput || document.querySelector('[' + HEADER_INPUT_ATTR + ']');
    }
    moveInstantResultsToMount(visible, overlayOpen, inputForMount);
  }

  var MOUNT_SEL = '[data-snize-instant-search-mount]';

  /**
   * Reparent Snize’s #snize-instant-search-results from body into the header shell mount so the pill
   * and dropdown share one .snize-header-search-stack card (CSS). Restores to body when overlay closes.
   */
  function moveInstantResultsToMount(visible, overlayOpen, input) {
    var ac = document.getElementById(AC_RES_ID);
    if (!ac) return;

    var field = input;
    if (!field || !field.getAttribute || field.getAttribute(HEADER_INPUT_ATTR) === null) {
      field = cachedInput || document.querySelector('[' + HEADER_INPUT_ATTR + ']');
    }
    var root = field && field.closest && field.closest(ROOT_SEL);
    var mount = root && root.querySelector(MOUNT_SEL);

    if (mount && visible && overlayOpen) {
      if (ac.parentNode !== mount) {
        try {
          mount.appendChild(ac);
        } catch (e) {
          warn('moveInstantResultsToMount: appendChild failed', e);
        }
      }
      return;
    }

    if (ac.closest(MOUNT_SEL) && document.body) {
      try {
        document.body.appendChild(ac);
      } catch (e2) {
        warn('moveInstantResultsToMount: restore to body failed', e2);
      }
    }
  }

  function scheduleAutocompleteVisualSync() {
    if (acSyncTimer) clearTimeout(acSyncTimer);
    acSyncTimer = setTimeout(function () {
      acSyncTimer = null;
      syncAutocompleteVisualConnection();
    }, 16);
  }

  function installAutocompleteVisualSync() {
    scheduleAutocompleteVisualSync();
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function () {
      scheduleAutocompleteVisualSync();
    });
    try {
      mo.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
      });
    } catch (e) {
      warn('Autocomplete visual sync: MutationObserver failed', e);
    }
    document.addEventListener('focusin', scheduleAutocompleteVisualSync, true);
  }

  function closeOtherHeaderPanels(keepRoot) {
    document.querySelectorAll(ROOT_SEL).forEach(function (r) {
      if (r !== keepRoot) closePanel(r);
    });
  }

  /** @param {Element} trigger */
  function getAnchorFromTrigger(trigger) {
    var root = trigger.closest(ROOT_SEL);
    if (!root) return null;
    var el = root.querySelector('[' + HEADER_INPUT_ATTR + ']');
    if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')) {
      return el;
    }
    return null;
  }

  /**
   * Theme header field(s); first in DOM for generic Snize init / cache fallback.
   */
  function resolveThemeHeaderAnchor() {
    var el = document.querySelector('[' + HEADER_INPUT_ATTR + ']');
    if (el && el.tagName === 'INPUT') {
      log('STEP resolve-anchor: using first [' + HEADER_INPUT_ATTR + ']');
      return el;
    }
    log('STEP resolve-anchor: no [' + HEADER_INPUT_ATTR + '] (search snippet not rendered?)');
    return null;
  }

  function resolveInputFromSearchInputConfig() {
    var sn = window.Searchanise;
    log('STEP resolve: window.Searchanise exists?', !!sn);
    if (!sn) return null;

    var keys = Object.keys(sn).filter(function (k) {
      return /^[A-Za-z]/.test(k);
    });
    log('STEP resolve: Searchanise public keys (sample):', keys.slice(0, 40));
    var fnames = keys.filter(function (k) {
      return typeof sn[k] === 'function';
    });
    log('STEP resolve: Searchanise function names (sample):', fnames.slice(0, 25));

    var si = sn.SearchInput;
    log('STEP resolve: Searchanise.SearchInput =', si, '(type ' + typeof si + ')');

    var $ = getSearchaniseJquery();
    log('STEP resolve: Searchanise.$ is function?', typeof sn.$ === 'function');
    if (!$) {
      warn('STEP resolve: Searchanise.$ missing — widget jQuery not ready');
      return null;
    }

    if (typeof si !== 'string' || !si.trim()) {
      warn('STEP resolve: SearchInput is not a non-empty string; cannot use Widgets JS API selector');
      return null;
    }

    var $set = $(si);
    var n = $set && $set.length;
    log('STEP resolve: jQuery("' + si + '") matched', n, 'element(s)');
    if (!n) {
      warn('STEP resolve: selector matches nothing in DOM. Inspect Elements for the real search field.');
      return null;
    }

    function pickBestInput($all) {
      var $header = $all.filter('[' + HEADER_INPUT_ATTR + ']');
      if ($header.length) {
        log('STEP resolve: pick — [' + HEADER_INPUT_ATTR + '] among matches:', $header.length);
        return $header.first()[0];
      }
      var $snize = $all.filter('.snize-input-style');
      if ($snize.length) {
        log('STEP resolve: pick — .snize-input-style among matches:', $snize.length);
        return $snize.first()[0];
      }
      var $inSnize = $all.filter(function () {
        return !!$(this).closest('[class*="snize"], [id*="snize"]').length;
      });
      if ($inSnize.length) {
        log('STEP resolve: pick — inside [class|id*="snize"]:', $inSnize.length);
        return $inSnize.first()[0];
      }
      var $vis = $all.filter(function () {
        try {
          return $(this).is(':visible');
        } catch (e) {
          return true;
        }
      });
      if ($vis.length) {
        log('STEP resolve: pick — :visible among matches:', $vis.length);
        return $vis.first()[0];
      }
      log('STEP resolve: pick — first node in set (fallback)');
      return $all[0];
    }

    var el = pickBestInput($set);
    if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')) {
      log('STEP resolve: chosen element', describe(el));
      return el;
    }
    warn('STEP resolve: chosen node is not INPUT/TEXTAREA:', describe(el));
    return null;
  }

  function activateInput(input) {
    log('STEP activate: focusing', describe(input));
    var $ = getSearchaniseJquery();
    if ($) {
      try {
        $(input).trigger('focus');
      } catch (e) {
        warn('STEP activate: jQuery trigger(focus) failed', e);
      }
    }
    try {
      input.focus({ preventScroll: true });
    } catch (e) {
      try {
        input.focus();
      } catch (e2) {
        warn('STEP activate: focus() failed', e2);
      }
    }
    try {
      input.click();
    } catch (e) {
      warn('STEP activate: click() failed', e);
    }
  }

  function refreshCache(reason) {
    log('STEP cache: refresh ("' + reason + '")');
    var anchor = resolveThemeHeaderAnchor();
    if (anchor) {
      cachedInput = anchor;
      log('STEP cache: pinned to theme header anchor', describe(cachedInput));
      return cachedInput;
    }
    cachedInput = resolveInputFromSearchInputConfig();
    if (cachedInput) log('STEP cache: cached (SearchInput config)', describe(cachedInput));
    else warn('STEP cache: no input cached');
    return cachedInput;
  }

  function isLikelySnizeUi(target) {
    return !!(target.closest && target.closest('[class*="snize"], [id*="snize"], .snize-search-results'));
  }

  function onDocumentClickClose(e) {
    /* Theme controls first: on Snize-heavy pages (e.g. custom search-results page) the pill lives
     * inside [class*="snize"] markup — isLikelySnizeUi would run first and skip these. */
    if (e.target.closest && e.target.closest('[data-header-searchanise-backdrop]')) {
      document.querySelectorAll(ROOT_SEL).forEach(closePanel);
      return;
    }
    if (e.target.closest && e.target.closest('[data-header-searchanise-close]')) {
      var closeBtn = e.target.closest('[data-header-searchanise-close]');
      var root = closeBtn && closeBtn.closest(ROOT_SEL);
      if (root) closePanel(root);
      return;
    }
    if (isLikelySnizeUi(e.target)) return;
    if (e.target.closest && e.target.closest(ATTR)) return;
    if (e.target.closest && e.target.closest('[data-header-searchanise-panel]')) return;
    document.querySelectorAll(ROOT_SEL).forEach(closePanel);
  }

  function onEscape(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(ROOT_SEL).forEach(closePanel);
  }

  function onHeaderClick(e) {
    var trigger = e.target.closest && e.target.closest(ATTR);
    if (!trigger) return;

    var root = trigger.closest(ROOT_SEL);
    if (!root) return;

    log('STEP 1: Header trigger click — event received', {
      target: describe(e.target),
      trigger: describe(trigger),
      type: e.type,
    });

    if (isPanelOpen(root)) {
      log('STEP 1b: panel open — closing (toggle)');
      closePanel(root);
      return;
    }

    closeOtherHeaderPanels(root);
    openPanel(root);

    var input = getAnchorFromTrigger(trigger);
    if (input) {
      cachedInput = input;
      log('STEP 2: anchor from this header instance', describe(input));
    }

    log('STEP 2: Searchanise loaded?', !!window.Searchanise);
    logSearchaniseScripts();

    function focusWhenReady() {
      var field = getAnchorFromTrigger(trigger) || cachedInput || refreshCache('panel open');
      if (!field) {
        warn('STEP 3 FAIL: Could not resolve input. Run debugSearchaniseHeader() in console after page load.');
        logSnizeLikeRoots();
        var attempts = 0;
        var id = setInterval(function () {
          attempts += 1;
          log('STEP 3 retry', attempts, '/ 40');
          field = getAnchorFromTrigger(trigger) || refreshCache('retry ' + attempts);
          if (field || attempts >= 40) clearInterval(id);
          if (field) activateInput(field);
        }, 125);
        return;
      }
      activateInput(field);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(focusWhenReady);
    });
  }

  function onSearchaniseLoaded() {
    log('EVENT Searchanise.Loaded fired');
    refreshCache('Searchanise.Loaded');
    logIframes();

    var $ = getSearchaniseJquery();
    if ($) {
      $(document).on('Searchanise.AutocompleteUpdated.searchaniseHeader', function (event, input) {
        var node = input && input[0];
        if (node && node.getAttribute && node.getAttribute(HEADER_INPUT_ATTR) !== null) {
          cachedInput = node;
          log('EVENT AutocompleteUpdated: reaffirmed header anchor', describe(cachedInput));
        }
        scheduleAutocompleteVisualSync();
      });
    }
  }

  function install() {
    log('INSTALL: binding capture click on document for', ATTR);
    document.addEventListener('click', onHeaderClick, true);
    document.addEventListener('click', onDocumentClickClose, false);
    document.addEventListener('keydown', onEscape, true);

    if (window.Searchanise) {
      log('INSTALL: Searchanise already on window before listener install');
      queueMicrotask(onSearchaniseLoaded);
    } else {
      log('INSTALL: waiting for Searchanise.Loaded');
      document.addEventListener('Searchanise.Loaded', onSearchaniseLoaded, { once: true });
    }

    log('INSTALL: initial script scan');
    logSearchaniseScripts();
    installAutocompleteVisualSync();
  }

  window.debugSearchaniseHeader = function () {
    log('=== debugSearchaniseHeader() ===');
    log('Searchanise:', window.Searchanise);
    logSearchaniseScripts();
    logIframes();
    logSnizeLikeRoots();
    refreshCache('manual debug');
    var btn = document.querySelector(ATTR);
    log('Header trigger in DOM?', !!btn, btn ? describe(btn) : '');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
